var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.90239 2.97551C4.97631 2.97551 3.41821 4.53365 3.41821 6.45513C3.41821 7.27283 3.69982 8.02233 4.16774 8.61742C4.8037 9.42146 5.79401 9.93931 6.90239 9.93931C8.01077 9.93931 8.99651 9.42146 9.63246 8.61742C10.1003 8.02233 10.382 7.27283 10.382 6.45513C10.382 4.53365 8.8239 2.97551 6.90239 2.97551Z",
    fill: "#828282"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3771 8.89279C10.3305 8.95925 10.2849 9.02617 10.2343 9.09057C9.41696 10.1235 8.19573 10.7149 6.88165 10.7149C5.56464 10.7149 4.34154 10.1236 3.52566 9.09244C3.47482 9.02777 3.429 8.96051 3.38219 8.89374C1.38907 9.77692 0 11.7671 0 14.0865V16.2014H13.7631V14.0865C13.7631 11.7673 12.3707 9.77365 10.3771 8.89279Z",
    fill: "#828282"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1185 0C9.61061 0 8.3297 0.94739 7.82837 2.27659C9.72886 2.70894 11.153 4.4091 11.153 6.43875C11.153 6.63965 11.1343 6.83693 11.107 7.03224C11.1109 7.03228 11.1146 7.03293 11.1185 7.03293C12.2379 7.03293 13.2334 6.50997 13.8757 5.69793C14.3482 5.09698 14.6327 4.34002 14.6327 3.5142C14.6327 1.5736 13.0591 0 11.1185 0Z",
    fill: "#828282"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.614 5.96817C14.5674 6.03463 14.5218 6.10155 14.4712 6.16595C13.6539 7.19888 12.4326 7.79032 11.1186 7.79032C11.0571 7.79032 10.9971 7.78263 10.9361 7.78008C10.8848 7.93501 10.826 8.08743 10.7571 8.23593C12.7966 9.1685 14.1874 11.0873 14.4659 13.2768H17.9999V11.1619C18 8.84272 16.6076 6.84902 14.614 5.96817Z",
    fill: "#828282"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/addIcon.9fd9369e3fc9d065c24bb5c68b197b36.svg";
export { ForwardRef as ReactComponent };